














import { DmsBaseComponent } from '#components/dms/common/base';

export default DmsBaseComponent.extend({
	name: 'DmsCollapseItem',
	computed: {
		titleText() {
			return this.getText(this.label, this.labelKey, undefined, this.LocalizePopisostatni);
		},
		isButtonsVisible(): boolean {
			return !!this.$slots.userDefinedButtons;
		},
	},
});
